import { DefaultButton, IconButton } from 'office-ui-fabric-react/lib/Button';
import React, { Component, Fragment } from 'react';
import Scriba from 'react-scriba';
import { DataAlarme } from '../../data/DataAlarme';
import { DataContact } from '../../data/DataContact';
import { Immocom } from '../../specifique/immocom';
import { EUIModal } from '../EUI/EUIModal';
import { EUIPage } from '../EUI/EUIPage';
import { DetailsListAlarme } from '../List/DetailsListAlarme';

export class Prospection extends Component {

    constructor(props) {
        super(props);
        this.state = {
            afficherModalAlarmes: false,
            peutAccederSouhaits: false,
            peutAccederSouhaitsMaisonIndividuelle: false,
            peutAccederOriginesContacts: false,
            peutGererAlarmesSouhait: false,
            peutAccederRepartiteur: false
        }
    };

    _chargementDroits = () => {
        let chargementListeDesDroitsFicheContact = DataContact._chargementListeDesDroitsFicheContact();

        chargementListeDesDroitsFicheContact
            .then(responseFetch => {
                let retourVerif = Scriba.fetch().traitementRetour(responseFetch, this, 100);

                if (retourVerif.hideMessageBarWarning && retourVerif.hideMessageBarError) {
                    const listDroits = responseFetch.reponseAPIobjet;

                    const peutAccederSouhaits = listDroits[3]; //a un mandat de type de programme correspondant au souhait normal
                    const peutAccederSouhaitsMaisonIndividuelle = listDroits[4]; //a un mandat de type de programme correspondant au souhait maison individuelle
                    const peutGererAlarmesSouhait = listDroits[5];
                    const peutAccederOriginesContacts = listDroits[8];
                    const peutAccederRepartiteur = listDroits[9];
                    this.setState(
                        {
                            peutAccederSouhaits,
                            peutAccederSouhaitsMaisonIndividuelle,
                            peutAccederOriginesContacts,
                            peutGererAlarmesSouhait,
                            peutAccederRepartiteur
                        }
                    );
                }
                else {
                    const stateTemp = {
                        peutAccederSouhaits: false,
                        peutAccederSouhaitsMaisonIndividuelle: false,
                        peutAccederOriginesContacts: false,
                        peutGererAlarmesSouhait: false,
                        peutAccederRepartiteur: false
                    };
                    Immocom.onTraitementErreurAvecState(this, stateTemp, retourVerif, responseFetch);
                }
            });
    }

    _getButtons = () => {
        let buttons = [];
        if (this.state.peutGererAlarmesSouhait)
            buttons.push(<IconButton
                ariaLabel="Afficher les alarmes actives"
                iconProps={{ iconName: "Ringer" }}
                key="alarms"
                onClick={this._toggleModalAlarmes(true)}
                title="Afficher les alarmes"
            />);
        return buttons;
    };

    _toggleModalAlarmes = (isOpen) => () => {
        this.setState({ afficherModalAlarmes: isOpen });
    };

    componentDidMount = () => {
        this._chargementDroits();
    };

    render = () => <Fragment>

        <EUIPage
            baseUrl="/Prospection"
            buttons={this._getButtons()}
            onglets={[
                { url: "/ListeContacts", titre: "Contacts" },
                { url: "/ListeSouhaits", titre: "Souhaits", hidden: !this.state.peutAccederSouhaits },
                { url: "/ListeSouhaitsMaisonsIndividuelles", titre: "Souhaits Maisons ind.", hidden: !this.state.peutAccederSouhaitsMaisonIndividuelle },
                { url: "/ListeDenonciations", titre: "Dénonciations" },
                { url: "/ListeOriginesContacts", titre: "Origines Contacts", hidden: !this.state.peutAccederOriginesContacts },
                { url: "/ListeRepartiteurs", titre: "Répartiteur", hidden: !this.state.peutAccederRepartiteur }
            ]}
        />

        <EUIModal
            buttons={[<DefaultButton key="close" onClick={this._toggleModalAlarmes(false)} text="Fermer" name="BoutonFermer" />]}
            isOpen={this.state.afficherModalAlarmes}
            onDismiss={this._onCacheModalAlarmes}
            titre="Alarmes actives"
        >
            <DetailsListAlarme activerCreation={false} activerFiltres={false} afficherAlarmesLieesASouhaits afficherAlarmesInactives={false} />
        </EUIModal>

    </Fragment>;

}